import styled, { css } from 'styled-components';
import { ReactComponent as WaveDefaultSVG } from 'Public/graphics/bannerLink/wave-banner-link.svg';
import { ReactComponent as WaveAltSVG } from 'Public/graphics/bannerLink/wave-banner-link-alt.svg';

import BaseLinkArrow from 'Elements/Link/Arrow';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: ${theme.colors.tertiary.hex};
        height: 4rem;

        @media ${theme.breakpoints.xlarge.media} {
            height: 5rem;
        }
    `}
`;

export const Background = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
`;

export const DefaultWave = styled(WaveDefaultSVG)`
    ${({ theme }) => css`
        position: absolute;
        background-size: 100% 100%;
        transform: translateY(50%);
        bottom: 2rem;
        right: -31rem;
        height: 4rem;

        @media ${theme.breakpoints.medium.media} {
            bottom: 2rem;
            right: -14rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            bottom: 2.5rem;
            right: -20rem;
            height: 6rem;
        }

        @media ${theme.breakpoints.huge.media} {
            bottom: 2rem;
            right: -12rem;
        }
    `}
`;

export const AltWave = styled(WaveAltSVG)`
    ${({ theme }) => css`
        position: absolute;
        bottom: 4rem;
        left: 0;
        transform: translateY(50%) rotate(14deg);
        background-size: 100% 100%;
        height: 35rem;

        @media ${theme.breakpoints.medium.media} {
            bottom: 5rem;
            left: -2rem;
            height: 35rem;
        }

        @media ${theme.breakpoints.large.media} {
            bottom: 5rem;
        }

        @media ${theme.breakpoints.huge.media} {
            height: auto;
        }
    `}
`;

export const PromoLink = styled(BaseLinkArrow)`
    ${({ theme }) => css`
        z-index: 1;
        text-decoration: none;
        font-size: 1rem;
        line-height: 1;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.2rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }
    `}
`;
